import { FaGithub } from "react-icons/fa";
import { TbWorldWww } from "react-icons/tb";
import { IoImages } from "react-icons/io5";

const RightMenu = () => {

  return (
    <div className="flex flex-col space-y-0">
      <button 
      onClick={() => console.log('github')}
      className="bg-beige px-4 py-3 border-b-0 border border-black"> <FaGithub/></button>
      <button 
      onClick={() => console.log('github')}
      className="bg-beige px-4 py-3 border-b-0 border border-black"> <TbWorldWww/></button>
      <button 
      onClick={() => console.log('github')}
      className="bg-beige px-4 py-3 border border-black"> <IoImages/></button>
    </div>
  )
}

export default RightMenu;